"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateReceiverEmail = exports.validatePassword = exports.requiredNumeric = exports.required = exports.numeric = exports.notDefault = exports.noWhiteSpace = exports.minTime = exports.minLength = exports.minDate = exports.maxTime = exports.maxLength = exports.maxFileSize = exports.maxDate = exports.matchingPassword = exports.lessThanValue = exports.isValidPhone = exports.isDate = exports.greaterThanZero = exports.greaterThanValue = exports.greaterThanOrEqualToZero = exports.greaterThanOrEqualToValue = exports.email = exports.alphanumericspace = exports.alphanumeric = exports.alphabetic = exports.allowedNumberValuesRange = void 0;
var _bignumber = require("bignumber.js");
var _libphonenumberJs = require("libphonenumber-js");
var _metadataMin = _interopRequireDefault(require("libphonenumber-js/metadata.min.json"));
var _dateHelper = require("./dateHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var required = exports.required = function required(value) {
  return value ? undefined : 'Required';
};
// t('Required')

var notDefault = exports.notDefault = function notDefault(value) {
  return value !== 'default' ? undefined : 'Required';
};
var requiredNumeric = exports.requiredNumeric = function requiredNumeric(value) {
  return value !== undefined && value !== '' ? undefined : 'Required';
};
// t('Required')

var matchingPassword = exports.matchingPassword = function matchingPassword(value, allValues) {
  return value !== allValues.password ? 'Passwords do not match' : undefined;
};
// t('Passwords do not match')

var email = exports.email = function email(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'Invalid email address' : undefined;
};
// t('Invalid email address')

var validateReceiverEmail = exports.validateReceiverEmail = function validateReceiverEmail(value, userEmail) {
  return value === userEmail ? "You can't use your own email as receiver address" : undefined;
};
// t(`You can't use your own email as receiver address`)

var noWhiteSpace = exports.noWhiteSpace = function noWhiteSpace(value) {
  return value && /\s/.test(value) ? 'Must not contain whitespace' : undefined;
};
// t('Must not contain whitespace')

var alphanumeric = exports.alphanumeric = function alphanumeric(value) {
  return value && !/^[a-z0-9]*$/i.test(value) ? 'Input should only contain alphanumeric characters' : undefined;
};
// t('Input should only contain alphanumeric characters')

var alphabetic = exports.alphabetic = function alphabetic(value) {
  return value && !/^[a-z]*$/i.test(value) ? 'Input should only contain alphabetic characters' : undefined;
};
// t('Input should only contain alphabetic characters')

var alphanumericspace = exports.alphanumericspace = function alphanumericspace(value) {
  return !/^[a-z\d\s]*$/i.test(value) ? 'Input should only contain alphanumeric and space characters' : undefined;
};
// t('Input should only contain alphanumeric and space characters')

var numeric = exports.numeric = function numeric(value) {
  return value && !/^\d*$/i.test(value) ? 'Input should only contain numeric characters' : undefined;
};
// t('Input should only contain numeric characters')

var greaterThanValue = exports.greaterThanValue = function greaterThanValue(min) {
  return function (value) {
    return value !== undefined && value <= min ? "Must be greater than ".concat(min) : undefined;
  };
};
/* t('Must be greater than {{a}}') */

var greaterThanOrEqualToValue = exports.greaterThanOrEqualToValue = function greaterThanOrEqualToValue(min) {
  return function (value) {
    return value !== undefined && value !== '' && value < min ? "Must be greater than or equal to ".concat(min) : undefined;
  };
};
/* t('Must be greater than or equal to {{a}}') */

var lessThanValue = exports.lessThanValue = function lessThanValue(max, value) {
  return value && value > max ? "Must be less than ".concat(max) : undefined;
};
/* t('Must be less than {{a}}') */

var allowedNumberValuesRange = exports.allowedNumberValuesRange = function allowedNumberValuesRange(min, max) {
  return function (value) {
    var formattedValue = new _bignumber.BigNumber(value);
    var formattedMaxValue = new _bignumber.BigNumber(max);
    return typeof value !== 'undefined' && (formattedValue.isLessThanOrEqualTo(min) || formattedValue.isGreaterThanOrEqualTo(formattedMaxValue)) ? "Allowed value must be greater than ".concat(min, " and less than ").concat(max) : undefined;
  };
};
/* context.t('Allowed value must be greater than {a} and less than {b}', {
   a: min,
   b: max
}) */

var greaterThanZero = exports.greaterThanZero = greaterThanValue(0);
var greaterThanOrEqualToZero = exports.greaterThanOrEqualToZero = greaterThanOrEqualToValue(0);
var validatePassword = exports.validatePassword = function validatePassword(value) {
  return value && !value.match(window.APEXWebConfig.global.PasswordRegexPattern) ? window.APEXWebConfig.global.DefaultPasswordRegexErrorMessage : undefined;
};
// t('Password must contain at least 8 characters, one number, and at least one capital letter')

var isDate = exports.isDate = function isDate(value) {
  var isInvalid = Object.prototype.toString.call(value) === '[object Date]' ? isNaN(value.getTime()) : true;
  return value && isInvalid ? 'Invalid date' : undefined;
};
// t('Invalid date')

var maxLength = exports.maxLength = function maxLength(max) {
  return function (value) {
    return value && value.length > max ? "Must be ".concat(max, " characters or less") : undefined;
  };
};
/* t('Must be {{a}} characters or less') */

var minLength = exports.minLength = function minLength(min) {
  return function (value) {
    return value && value.length < min ? "Must be ".concat(min, " characters or more") : undefined;
  };
};
/* t('Must be {{a}} characters or more') */

var isValidPhone = exports.isValidPhone = function isValidPhone(value) {
  return (0, _libphonenumberJs.isValidNumber)(value, _metadataMin["default"]) ? undefined : 'Must be a valid phone number';
};
// t('Must be a valid phone number')

var maxFileSize = exports.maxFileSize = function maxFileSize(value, maxSize) {
  return value && value.file && maxSize <= value.file.size / 1024 / 1024 ? "File size must be under ".concat(maxSize, "mb") : undefined;
};

/* t('File size must be under {{a}}mb') */

var maxDate = exports.maxDate = function maxDate(value, _maxDate) {
  return value && value > _maxDate ? "Date must be before ".concat((0, _dateHelper.formatDate)(_maxDate)) : undefined;
};

/* t('Date must be before {{a}}') */

var minDate = exports.minDate = function minDate(value, _minDate) {
  return value && value < _minDate ? "Date must be after ".concat((0, _dateHelper.formatDate)(_minDate)) : undefined;
};

/* t('Date must be after {{a}}') */

var minTime = exports.minTime = function minTime(value, _minTime) {
  if (!value) return;
  var time = getTimeObj(value);
  var min = getTimeObj(_minTime);
  return time.hours < min.hours || time.hours === min.hours && time.minutes < min.minutes ? "Time must be after ".concat((0, _dateHelper.formatTime)(_minTime)) : undefined;
};

/* t('Time must be after {{a}}') */

var maxTime = exports.maxTime = function maxTime(value, _maxTime) {
  if (!value) return;
  var time = getTimeObj(value);
  var max = getTimeObj(_maxTime);
  return time.hours > max.hours || time.hours === max.hours && time.minutes > max.minutes ? "Time must be before ".concat((0, _dateHelper.formatTime)(_maxTime)) : undefined;
};

// t('Time must be before {{a}}')

var getTimeObj = function getTimeObj(date) {
  return {
    hours: date.getHours(),
    minutes: date.getMinutes()
  };
};